import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const apiSlice = createApi({
  reducerPath: 'api', // Unique key for caching
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/v1',
    prepareHeaders: (headers, { getState }) => {
      const token = getState().app.token; // Access token from Redux store

      if (token) {
        headers.set('Authorization', `Bearer ${token}`); // Attach token if available
      }

      return headers;
    },

    serializeQueryArgs: ({ endpointName, queryArgs, getState }) => {
      const token = getState().app.token;
      // add token to the cache key
      return `${endpointName}-${JSON.stringify(queryArgs)}-${token}`;
    },
  }),

  tagTypes: [
    'Audiences',
    'Audience',
    'Campaigns',
    'Campaign',
    'Templates',
    'UserFonts',
    'CompanyParams',
    'CompanyParam',
    'Users',
    'User',
  ], // Multiple tags
  endpoints: () => ({}), // Initially empty
});

export default apiSlice;
